import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBoat: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBoat"><Path d="M13.5 16.5V2.5C13.5 2.5 5.56667 6.76786 3.5 13.5C8.71256 12.8383 14.2921 12.9668 19.5 13.5C18.4323 9.57615 16.5833 6.55357 14 5" stroke="currentColor" strokeLinecap="square"/><Path d="M5.5 21.5L2.5 16.5H21.5L18.5 21.5H5.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBoat;
